/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductSelectionViewModel } from './ProductSelectionViewModel';
import {
    ProductSelectionViewModelFromJSON,
    ProductSelectionViewModelFromJSONTyped,
    ProductSelectionViewModelToJSON,
} from './ProductSelectionViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfProductSelectionViewModel
 */
export interface ResultOfProductSelectionViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfProductSelectionViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProductSelectionViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProductSelectionViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProductSelectionViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProductSelectionViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfProductSelectionViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfProductSelectionViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ProductSelectionViewModel}
     * @memberof ResultOfProductSelectionViewModel
     */
    data?: ProductSelectionViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProductSelectionViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfProductSelectionViewModel interface.
 */
export function instanceOfResultOfProductSelectionViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfProductSelectionViewModelFromJSON(json: any): ResultOfProductSelectionViewModel {
    return ResultOfProductSelectionViewModelFromJSONTyped(json, false);
}

export function ResultOfProductSelectionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfProductSelectionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ProductSelectionViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfProductSelectionViewModelToJSON(value?: ResultOfProductSelectionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ProductSelectionViewModelToJSON(value.data),
        'Count': value.count,
    };
}

